<div>
  <div style="background-color: white; overflow: visible;">
    <mat-toolbar style="background: transparent; width: fit-content; block-size: fit-content; margin-right: 15px; float: left; ">
      <mat-toolbar-row style="height: 40px">
        <span class="title" style="color: #7492B3">Filter:&nbsp;</span>

        <span data-cy=scheduleFlights [ngClass]="{'activeButton': showPlannedFlights,'inactiveButton': !showPlannedFlights}"
              (click)="togglePlannedFlights()">
          Planerade flyg
        </span>
        <label class="separator">|</label>
        <span data-cy=finishedActivites [ngClass]="{'activeButton': showFinishedEvents,'inactiveButton': !showFinishedEvents}"
              (click)="toggleFinishedEvents()">
          Färdiga uppdrag
        </span>
        <label class="separator">|</label>
        <span data-cy=showAllDrivers [ngClass]="{'activeButton': showAllDrivers,'inactiveButton': !showAllDrivers}"
              (click)="toggleAllDrivers()">
          Alla chaufförer
        </span>
        <label class="separator">|</label>
        <span data-cy=showLandsideDrivers [ngClass]="{'activeButton': showLandside,'inactiveButton': !showLandside}"
              (click)="toggleLandside()">
          Landside
        </span>
      </mat-toolbar-row>
    </mat-toolbar>
    <div style="float: left; margin-top: 8px">
      <img data-cy=assignAllPlaned class="transfer-button" *ngIf="!canAssignPlanned()" [ngClass]="{'inactiveAssignButton': !canAssignPlanned()}" src="/assets/images/button_assign_all.svg" title="Tilldela planerade" alt="Tilldela planerade" (click)="assignPlanned()" />
      <img data-cy=assignAllPlaned class="transfer-button" *ngIf="canAssignPlanned()" src="/assets/images/button_assign_all_2.svg" title="Tilldela planerade" alt="Tilldela planerade" (click)="assignPlanned()" />
      <img data-cy=createTransfer class="transfer-button" src="/assets/images/transfer_create.svg" title="Skapa transfer" alt="Skapa transfer" (click)="createTransfer($event)" />

    </div>
    <div style="float: right; margin-right: 10px; margin-top: 10px">
      <span *ngFor="let state of states" matTooltip="{{state.translated}}" style="margin-left: 10px;">
        <span class="dot" [ngStyle]="{'background-color': stateBgColor(state)}"></span>
        <span style="font-weight: bold; font-size: 12px">{{state.text}}</span>
      </span>
    </div>

    <div id="daypilot" class="normalScreen">
      <div id="daypilot-portlet" class="schedule_container">
        <div class="section">
          <div id="daypilot-planned" class="content" data-cy="dayPilot">
            <app-scheduler-upper #schedulerUpper (heightChanged)="onUpperScheduleHeightChanged($event)" (onPlannedActivities)="onPlannedActivities($event)"> </app-scheduler-upper>
          </div>
          <div id="daypilot-unplanned" data-cy="dayPilotSchedule" class="scrollable-content content">
            <daypilot-scheduler #scheduler></daypilot-scheduler>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
